"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { Cross2Icon, MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { IconButton } from "@radix-ui/themes";
import cx from "clsx";
import * as React from "react";
import { useDebouncedCallback } from "use-debounce";
import { TextField, TextFieldSlot } from "./elements";
import { useSearchContext } from "./search-provider";
import { useUsersManagementContext } from "./users-management-context";
import { namespaceClassNames } from "./utils";
export const UsersSearch = React.forwardRef(({ className, ...props }, ref) => {
    const { inputRef, clearSearch, searchValue, setSearchValue } = useSearchContext();
    const { dispatch } = useUsersManagementContext();
    const filter = useDebouncedCallback((value) => {
        dispatch({ type: "FILTER_BY_SEARCH", searchQuery: value });
    }, 200);
    const resetSearch = () => {
        clearSearch();
        filter.cancel();
    };
    return (_jsxs(TextField, { ref: useComposedRefs(inputRef, ref), className: cx(namespaceClassNames("users-search"), className), autoComplete: "off", placeholder: "Search by name or e-mail", value: searchValue, onChange: (event) => {
            const value = event.target.value;
            setSearchValue(value);
            filter(value);
        }, onKeyDown: (event) => {
            if (event.key === "Escape") {
                event.preventDefault();
                resetSearch();
            }
        }, ...props, children: [_jsx(TextFieldSlot, { side: "left", children: _jsx(MagnifyingGlassIcon, { "aria-hidden": "true", height: "16", width: "16" }) }), _jsx(TextFieldSlot, { side: "right", children: searchValue && (_jsx(IconButton, { size: "1", color: "gray", variant: "ghost", radius: "full", onClick: resetSearch, "aria-label": "Clear search", title: "Clear search", children: _jsx(Cross2Icon, { "aria-hidden": "true" }) })) })] }));
});
//# sourceMappingURL=users-search.js.map